import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
 
//ReactDOM.render(<App />, document.getElementById('odieworks_root'));

const rootNode = document.getElementById('odieworks_root');
ReactDOM.render(<App />, rootNode);
